import {
  AfterViewInit,
  Component, ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {GlobalService} from 'app/compartilhado/servicos/global.service';
import {Subscription, Observable} from 'rxjs';
import {Router} from '@angular/router';
import {AutoUnsubscribe} from '../../decorators/unsubscribe.decorator';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {LoaderService} from '../loader-interceptor/loader-interceptor.service';
import {InterceptorService} from '../../../interceptor-service';

declare const $: any;

@Component({
  selector: 'app-page-top',
  templateUrl: './page-top.component.html',
  styleUrls: ['./page-top.component.scss']
})

@AutoUnsubscribe
export class PageTopComponent implements OnInit, AfterViewInit, OnDestroy, HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  tema = this.globalService.tema;
  isMobile: boolean;
  subsTema: Subscription;
  subsPagamento: Subscription;
  @Input() nomePagina: string;
  @Input() nomePaginaInterpolation: string;
  @Input() nomePaginaFinal: string;
  @Input() mostrarPesquisa = true;
  @Input() mostrarRefresh = true;
  @Input() mostrarSair = true;
  @Input() mostrarHistorico = true;
  @Input() ocultarInformacoes = false;
  @Input() ShowHistory = true;
  @Input() nomeHistorico = '';
  @Input() itemIdHistorico;
  @Input() customHeader = false;
  @Input() loadingHeader = false; // Utilizado para exibir um Loading no topo da página
  @Input() overflow = true;
  @Input() mostrarFiltros = true;
  @Output() clickRefresh = new EventEmitter();
  @Output() clickPesquisa = new EventEmitter();
  @Output() clickFiltros = new EventEmitter();
  @ViewChild('buttonExibirFiltros') ExibirFiltros: ElementRef;
  showLoading = false;
  showPagamentoLoading = false;

  /*  Constrói a tela, instaciando todos os serviços a serem utilizados pela mesma
    Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor(private globalService: GlobalService,
              private router: Router,
              private loaderService: LoaderService,
              private interceptorService: InterceptorService) {


    this.loaderService.isLoading.subscribe(resposta => {
      this.showLoading = resposta;
    })

  }

  ngOnInit() {
    this.onResize();
    this.subsTema = this.globalService.temaSub.subscribe((tema) => {
      this.tema = tema;
    });
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })

    this.subsPagamento = this.globalService.pagamentoLoadingChanged.subscribe(resposta => {
      this.showPagamentoLoading = resposta;
    });
  }

  ngOnDestroy() {
  }

  onSair() {
    $('#botaoSair').tooltip('hide');
    this.router.navigate(['pesquisa']);
  }

  onHistorico() {
    $('#botaoHistorico').tooltip('hide');

    if (!this.itemIdHistorico) {
      this.router.navigate(['historicogeral', this.nomeHistorico]);
      return;
    }

    this.router.navigate(['historicogeral', this.nomeHistorico, this.itemIdHistorico]);
  }

  emitirRefresh() {
    this.clickRefresh.emit();
  }

  emitirFiltros() {
    this.clickFiltros.emit();

    if (this.globalService.auxExibirFiltros) {
      this.ExibirFiltros.nativeElement.dataset.originalTitle = 'Ocultar Filtros';
    } else {
      this.ExibirFiltros.nativeElement.dataset.originalTitle = 'Exibir Filtros';
    }

    this.onMouseOut('#mostrarFiltros');
  }

  onMouseOut(id: string) {
    $(id).tooltip('hide');
  }

  emitirPesquisa() {
    this.clickPesquisa.emit();
  }

  mudarSideBar() {
  }

  ngAfterViewInit() {
    this.globalService.overflowChanged.next(this.overflow);
  }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    if (this.requests.length === 0) {
      this.loaderService.isLoading.next(false);
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      this.requests.push(req);
      this.loaderService.isLoading.next(true);

    // We create a new observable which we return instead of the original
    return Observable.create(observer => {
      // And subscribe to the original observable to ensure the HttpRequest is made
      const subscription = next.handle(req)
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          err => {
            this.removeRequest(req);
            observer.error(err);
          },
          () => {
            this.removeRequest(req);
            observer.complete();
          });
      // return teardown logic in case of cancelled requests
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = this.globalService.isMobileExtra();
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  }
}
